import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getAADUserAccessDetailsReport = (loginId, startDate, endDate) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ACCESS_REPORT.GET_AAD_USER_ACCESS_DETAILS_REPORT(
      loginId,
      startDate,
      endDate
    )
  );
};

export default getAADUserAccessDetailsReport;
